import { render, staticRenderFns } from "./ConfirmEditCourseType.vue?vue&type=template&id=bd1aa336"
import script from "./ConfirmEditCourseType.vue?vue&type=script&lang=js"
export * from "./ConfirmEditCourseType.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEditCourseType.vue?vue&type=style&index=0&id=bd1aa336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports